import { StyleSheet } from 'aphrodite';

export const embeddedPreviewStyles = StyleSheet.create({
	backdrop: {
		position: 'relative',
		width: '100%',
		height: '100%',
		background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
		overflow: 'hidden',
	},
	/** Faux website chrome: subtle grid pattern */
	backdropPattern: {
		position: 'absolute',
		inset: 0,
		opacity: 0.4,
		backgroundImage:
			'linear-gradient(rgba(148,163,184,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.15) 1px, transparent 1px)',
		backgroundSize: '24px 24px',
		pointerEvents: 'none',
		flex: 1,
	},
	/** Root layout — anchored to bottom, holds launcher + panel */
	widgetRoot: {
		position: 'absolute',
		bottom: 16,
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'flex-end',
		gap: 12,
		zIndex: 1,
	},
	widgetRootRight: {
		right: 16,
		alignItems: 'flex-end',
	},
	widgetRootLeft: {
		left: 16,
		alignItems: 'flex-start',
	},
	/** Launcher button — matches the real widget exactly */
	launcher: {
		boxSizing: 'border-box',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 10,
		height: 56,
		width: 56,
		padding: 0,
		border: 'none',
		borderRadius: 999,
		background: 'oklch(0.5229 0.2442 263.47)',
		color: '#ffffff',
		boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
		cursor: 'default',
		pointerEvents: 'none',
	},
	launcherWithLabel: {
		width: 'auto',
		height: 48,
		padding: '16px 24px',
		maxWidth: 'min(320px, calc(100% - 32px))',
	},
	launcherIcon: {
		width: 24,
		height: 24,
		flexShrink: 0,
	},
	launcherLabel: {
		fontSize: 14,
		fontWeight: 600,
		lineHeight: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	/** Popup panel — matches the real widget panel */
	panel: {
		position: 'relative',
		width: 400,
		height: 600,
		maxWidth: 'calc(100% - 32px)',
		maxHeight: 'calc(100% - 100px)',
		borderRadius: 16,
		overflow: 'hidden',
		border: '1px solid rgba(15, 23, 42, 0.1)',
		boxShadow: '0 24px 48px rgba(2, 6, 23, 0.24)',
		background: '#ffffff',
		display: 'flex',
		flexDirection: 'column',
	},
	/** Close button in panel header */
	panelClose: {
		position: 'absolute',
		top: 10,
		right: 10,
		zIndex: 2,
		width: 28,
		height: 28,
		border: 'none',
		borderRadius: 999,
		background: 'rgba(15, 23, 42, 0.7)',
		color: '#ffffff',
		cursor: 'default',
		pointerEvents: 'none',
		lineHeight: 1,
		fontSize: 20,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	/** Scrollable content area inside the panel */
	panelContent: {
		flex: 1,
		overflowY: 'auto',
		padding: 0,
	},
});
